import { create } from "zustand";

type AlertsState = {
  isPanelOpen: boolean;
  filter: "all" | "unacknowledged";
  togglePanel: () => void;
  openPanel: () => void;
  closePanel: () => void;
  setFilter: (filter: "all" | "unacknowledged") => void;
};

const useAlertsStore = create<AlertsState>(set => ({
  isPanelOpen: false,
  filter: "unacknowledged",

  togglePanel: () => set(state => ({ isPanelOpen: !state.isPanelOpen })),
  openPanel: () => set({ isPanelOpen: true }),
  closePanel: () => set({ isPanelOpen: false }),
  setFilter: filter => set({ filter }),
}));

export default useAlertsStore;
